module.exports = {
	"Allocation": 652,
	"International Equity": 1099,
	"Sector Equity": 867,
	"U.S. Large Cap Equity": 1462,
	"U.S. Small/Mid Cap Equity": 1094
};


//////////////////
// WEBPACK FOOTER
// ./src/data/GefScoreNormalizersGroups.json
// module id = 965
// module chunks = 0